import { Navigate, useLocation } from 'react-router-dom';
import { useAuth  } from '../../features/auth/hooks/useAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Vérifier si l'utilisateur est authentifié
  if (!isAuthenticated) {
    // Rediriger vers la page de connexion en conservant l'URL cible
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si tout est bon, afficher les enfants
  return <>{children}</>;
};

export default ProtectedRoute;